module.exports = __webpack_public_path__ + "fd3a1a7a839c344aef58ab42faecf714.MP3";